import { Lexer } from './lexer.mjs';
import { Parser } from './parser.mjs';
import { Stringifier } from './stringifier.mjs';

const RISON = {
    parse: (text) => {
        const lexer = new Lexer(text);
        const parser = new Parser(lexer);
        return parser.readAsAny();
    },
    stringify: (value) => {
        const stringifier = new Stringifier();
        return stringifier.value(value);
    },
};
const ORISON = {
    parse: (text) => {
        const lexer = new Lexer(`(${text})`);
        const parser = new Parser(lexer);
        return parser.readAsAny();
    },
    stringify: (value) => {
        const stringifier = new Stringifier();
        return stringifier.object(value);
    },
};
const ARISON = {
    parse: (text) => {
        const lexer = new Lexer(`!(${text})`);
        const parser = new Parser(lexer);
        return parser.readAsAny();
    },
    stringify: (value) => {
        const stringifier = new Stringifier();
        return stringifier.array(value);
    },
};

export { ARISON, ORISON, RISON };
//# sourceMappingURL=rison.mjs.map
